import * as FILTER_TYPES from '@/finsight/application/actions/pageFilters/constants';
import { IMappingPairItem } from './types';

export const setWidgetsFilterData = (filters: IMappingPairItem) => {
  const modifiedFilters = { ...filters };

  if (modifiedFilters.sectorBlock) {
    modifiedFilters.getTopCompaniesBy = FILTER_TYPES.SECTOR;
    modifiedFilters.getChartBy = FILTER_TYPES.SECTOR;
    modifiedFilters.getDealsBy = FILTER_TYPES.SECTOR;
  } else {
    modifiedFilters.getTopCompaniesBy = FILTER_TYPES.INDUSTRY;
    modifiedFilters.getChartBy = FILTER_TYPES.INDUSTRY;
    modifiedFilters.getDealsBy = FILTER_TYPES.INDUSTRY;
  }

  return modifiedFilters;
};
